import(/* webpackMode: "eager" */ "/app/src/app/(auth)/layout.tsx");
